import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { BalanceService } from 'src/app/services/balance.service';
import { HttpService } from 'src/app/services/http.service';
import { LoginService } from 'src/app/services/login.service';
import { UiServices } from 'src/app/services/ui-services';

@Component({
  selector: 'app-cash-out',
  templateUrl: './cash-out.component.html',
  styleUrls: ['./cash-out.component.scss'],
})
export class CashOutComponent implements OnInit {
  public cashOut = {
    amount: 0,
    accountDetails: '',
  };

  constructor(
    public authSv: LoginService,
    public balanceSv: BalanceService,
    private httpSv: HttpService,
    private modalController: ModalController,
    private uiSv: UiServices
  ) {}

  ngOnInit() {}

  closeModal(refresh: boolean) {
    this.modalController.dismiss(refresh);
  }

  async sendCashOut() {
    const res = await this.httpSv.itemAction(
      this.cashOut,
      'withdrawalRequest',
      'store'
    );

    if (res.status) {
      await this.uiSv.presentAlert(
        'Su retiro ha sido solicitado con éxito',
        false
      );
      this.closeModal(true);
    }
  }
}
